import { render } from "./not-found-page.vue?vue&type=template&id=58d532e6&ts=true"
import script from "./not-found-page.vue?vue&type=script&lang=ts"
export * from "./not-found-page.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__